import * as XLSX from 'xlsx';

/**
 * exportToExcel(rows, columns, filename)
 *
 * rows    – array of objects
 * columns – [{ header: 'Display Name', key: 'field_name' }, ...]
 * filename – e.g. 'tickets-export.xlsx'
 */
export function exportToExcel(rows, columns, filename) {
  // Build array-of-arrays: header row + data rows
  const header = columns.map(c => c.header);
  const data = rows.map(row =>
    columns.map(c => {
      const val = row[c.key];
      if (val === null || val === undefined) return '';
      return val;
    })
  );

  const ws = XLSX.utils.aoa_to_sheet([header, ...data]);

  // Column widths based on header length (min 12, max 40)
  ws['!cols'] = columns.map(c => ({ wch: Math.min(40, Math.max(12, c.header.length + 4)) }));

  // Style header row cells
  const range = XLSX.utils.decode_range(ws['!ref']);
  for (let C = range.s.c; C <= range.e.c; C++) {
    const addr = XLSX.utils.encode_cell({ r: 0, c: C });
    if (!ws[addr]) continue;
    ws[addr].s = {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { patternType: 'solid', fgColor: { rgb: '1A5C38' } },
      alignment: { horizontal: 'center' },
    };
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Data');
  XLSX.writeFile(wb, filename);
}
